import { compileKennoView } from './compileKennoView';
const KENNO_VIEW_DEFINITIONS = [
    {
        key: 'contract',
        template: '/contracts/{id}',
        entityType: 'contract',
        label: 'Sopimus',
        requiredSections: ['housing'],
    },
    {
        key: 'contractMessages',
        template: '/contracts/{id}/messages',
        entityType: 'contract',
        label: 'Sopimuksen viestit',
        requiredSections: ['housing', 'communication'],
    },
    {
        key: 'contractPaymentStatus',
        template: '/ledger/contracts?selectedContractId={id}',
        entityType: 'contract',
        label: 'Sopimuksen maksutilanne reskontrassa',
        requiredSections: ['ledger'],
    },
    {
        key: 'rentalApartment',
        template: '/rentables/rental-apartment/{id}',
        entityType: 'rentalApartment',
        label: 'Vuokra-asunto',
        requiredSections: ['housing'],
    },
    {
        key: 'rentalApartmentViewings',
        template: '/rentables/rental-apartment/{id}/viewings',
        entityType: 'rentalApartment',
        label: 'Vuokra-asunnon näytöt',
        requiredSections: ['housing'],
    },
    {
        key: 'rightOfOccupancyApartment',
        template: '/rentables/right-of-occupancy/{id}',
        entityType: 'rightOfOccupancyApartment',
        label: 'Asumisoikeusasunto',
        requiredSections: ['housing'],
    },
    {
        key: 'rightOfOccupancyApartmentViewings',
        template: '/rentables/right-of-occupancy/{id}/viewings',
        entityType: 'rightOfOccupancyApartment',
        label: 'Asumisoikeusasunnon näytöt',
        requiredSections: ['housing'],
    },
    {
        key: 'retailPremises',
        template: '/rentables/retail-premises/{id}',
        entityType: 'retailPremises',
        label: 'Liiketila',
        requiredSections: ['housing'],
    },
    {
        key: 'rentalApplication',
        template: '/applications/rental-apartment/{id}',
        entityType: 'rentalApplication',
        label: 'Vuokrahakemus',
        requiredSections: ['applications'],
    },
    {
        key: 'rentalApplicationSuggestions',
        template: '/applications/rental-apartment/{id}/suggestions',
        entityType: 'rentalApplication',
        label: 'Vuokrahakemuksen asuntoehdotukset',
        requiredSections: ['applications'],
    },
    {
        key: 'rightOfOccupancyApplication',
        template: '/applications/right-of-occupancy/{id}',
        entityType: 'rightOfOccupancyApplication',
        label: 'Asumisoikeushakemus',
        requiredSections: ['applications'],
    },
    {
        key: 'notice',
        template: '/notices/{id}',
        entityType: 'notice',
        label: 'Vikailmoitus',
        requiredSections: [],
    },
    {
        key: 'workOrder',
        template: '/work-orders/{id}',
        entityType: 'workOrder',
        label: 'Työtilaus',
        requiredSections: [],
    },
    {
        key: 'inspection',
        template: '/inspections/{id}',
        entityType: 'inspection',
        label: 'Tarkastus',
        requiredSections: [],
    },
    {
        key: 'realProperty',
        template: '/real-properties/{id}',
        entityType: 'realProperty',
        label: 'Kiinteistö eli kohde',
        requiredSections: [],
    },
    {
        key: 'contracts',
        template: '/contracts',
        entityType: null,
        label: 'Sopimukset',
        requiredSections: ['housing'],
    },
    {
        key: 'rentables',
        template: '/rentables',
        entityType: null,
        label: 'Asunnot',
        requiredSections: ['housing'],
    },
    {
        key: 'rightOfOccupancyApartments',
        template: '/rentables/right-of-occupancy',
        entityType: null,
        label: 'Asumisoikeusasunnot',
        requiredSections: ['housing'],
    },
    {
        key: 'applications',
        template: '/applications',
        entityType: null,
        label: 'Hakemukset',
        requiredSections: ['applications'],
    },
    {
        key: 'ledgerMainView',
        template: '/ledger/main-view',
        entityType: null,
        label: 'Reskontra',
        requiredSections: ['ledger'],
    },
    {
        key: 'ledgerPaymentTypes',
        template: '/ledger/payment-types',
        entityType: null,
        label: 'Reskontra - Maksulajit',
        requiredSections: ['ledger'],
    },
    {
        key: 'ledgerContracts',
        template: '/ledger/contracts',
        entityType: null,
        label: 'Reskontra - Sopimukset',
        requiredSections: ['ledger'],
    },
    {
        key: 'ledgerBankAccounts',
        template: '/ledger/bank-accounts',
        entityType: null,
        label: 'Reskontra - Tilit',
        requiredSections: ['ledger'],
    },
    {
        key: 'ledgerAccounting',
        template: '/ledger/accounting',
        entityType: null,
        label: 'Reskontra - Kirjanpito',
        requiredSections: ['ledger'],
    },
    {
        key: 'ledgerOutgoingInvoices',
        template: '/ledger/outgoing-invoices',
        entityType: null,
        label: 'Reskontra - Lähtevät laskut',
        requiredSections: ['ledger'],
    },
    {
        key: 'ledgerPaymentOrders',
        template: '/ledger/payment-orders',
        entityType: null,
        label: 'Reskontra - Lähtevät maksut',
        requiredSections: ['ledger'],
    },
    {
        key: 'ledgerInvoicesAndBankTransactions',
        template: '/ledger/invoices-and-bank-transactions',
        entityType: null,
        label: 'Reskontra - Laskut ja maksut',
        requiredSections: ['ledger'],
    },
    {
        key: 'ledgerRightOfOccupancyFees',
        template: '/ledger/right-of-occupancy-fees',
        entityType: null,
        label: 'Reskontra - Asumisoikeusmaksut',
        requiredSections: ['ledger'],
    },
    {
        key: 'ledgerSecurityDeposits',
        template: '/ledger/security-deposits',
        entityType: null,
        label: 'Reskontra - Vakuudet',
        requiredSections: ['ledger'],
    },
    {
        key: 'ledgerWaterAndElectricity',
        template: '/ledger/water-electricity',
        entityType: null,
        label: 'Reskontra - Vesi ja sähkö',
        requiredSections: ['ledger'],
    },
    {
        key: 'ledgerInvoiceGroups',
        template: '/ledger/invoice-groups',
        entityType: null,
        label: 'Reskontra - Laskutusryhmät',
        requiredSections: ['ledger'],
    },
];
export const KENNO_VIEWS = KENNO_VIEW_DEFINITIONS.map(compileKennoView);
//# sourceMappingURL=kennoViews.js.map